const API_URL = 'https://prod-42.westeurope.logic.azure.com:443/workflows/1a6ff35dbdd44a87be0599a04668ce2c/triggers/manual/paths/invoke?api-version=2016-06-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=YdGWbodlgaJCcUbz-yeqvktyOIyl9JSVgkq-cFMwnZM';

/**
 * Send a contact email using the Power Automate flow
 * @param {Object} formData - Email data including form fields
 * @returns {Promise<Object>} Result of the email sending operation
 */
export const sendContactEmail = async (formData) => {
  try {
    // Generate HTML email with calculation data if available
    const htmlEmail = generateEmailHTML(formData);
    
    // Create clean request object without calculationData
    const requestBody = {
      name: formData.name || "",
      email: formData.email || "",
      company: formData.company || "",
      phone: formData.phone || "",
      message: formData.message || "",
      mail_body: htmlEmail
    };
    
    // Send request to Power Automate
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(requestBody)
    });

    // Simply check if the response is OK (status in 200-299 range)
    if (!response.ok) {
      const errorText = await response.text().catch(() => 'No response text');
      throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
    }

    // Don't try to parse the response at all, just return success
    return { 
      success: true, 
      data: { 
        status: response.status, 
        statusText: response.statusText 
      } 
    };
  } catch (error) {
    console.error('Email sending error:', error);
    return { success: false, error: error.message || 'Failed to send message' };
  }
};

/**
 * Generate HTML email template with contact and calculation data
 * @param {Object} formData - Complete form data with optional calculation results
 * @returns {string} HTML email content
 */
function generateEmailHTML(formData) {
  // Safely access calculation data, handling null and undefined cases
  const calculationData = formData.calculationData || null;
  
  // For debugging
  console.log("Calculation data for email:", calculationData);
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        body { font-family: Arial, sans-serif; line-height: 1.6; color: #333; }
        .container { max-width: 600px; margin: 0 auto; padding: 20px; }
        .header { background-color: #231f20; color: white; padding: 20px; text-align: center; }
        .content { padding: 20px; }
        .footer { background-color: #f5f5f5; padding: 20px; text-align: center; font-size: 12px; }
        .data-table { width: 100%; border-collapse: collapse; margin: 20px 0; }
        .data-table th, .data-table td { border: 1px solid #ddd; padding: 12px; text-align: left; }
        .data-table th { background-color: #f47216; color: white; }
        .highlight { color: #db1d2b; font-weight: bold; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Automation Factory ROI Inquiry</h1>
        </div>
        <div class="content">
          <h2>Contact Information</h2>
          <p><strong>Name:</strong> ${formData.name}</p>
          <p><strong>Email:</strong> ${formData.email}</p>
          <p><strong>Company:</strong> ${formData.company}</p>
          <p><strong>Phone:</strong> ${formData.phone}</p>
          ${formData.message ? `<p><strong>Message:</strong> ${formData.message}</p>` : ''}
          
          ${calculationData && typeof calculationData === 'object' ? `
          <h2>ROI Calculation Results</h2>
          <table class="data-table">
            <tr>
              <th colspan="2">Process Automation Details</th>
            </tr>
            <tr>
              <td>Difficulty Level</td>
              <td>${calculationData.difficultyLevel || 'Not specified'}</td>
            </tr>
            <tr>
              <td>Frequency</td>
              <td>${calculationData.frequencyType || 'Not specified'}</td>
            </tr>
            <tr>
              <td>Current Process Time (minutes)</td>
              <td>${calculationData.currentProcessTimeMinutes || '0'}</td>
            </tr>
            <tr>
              <td>Method Of Automation</td>
              <td>${calculationData.rpaType || 'Not specified'}</td>
            </tr>
            <tr>
              <td>Annual Cost Savings</td>
              <td class="highlight">€${(calculationData.annualCostSavings || 0).toLocaleString()}</td>
            </tr>
            <tr>
              <td>ROI Percentage</td>
              <td class="highlight">${calculationData.roi || '0'}%</td>
            </tr>
          </table>
          ` : `
          <p><em>No ROI calculation data was provided.</em></p>
          `}
          
          <p>Please contact this customer to discuss the automation opportunity in more detail.</p>
        </div>
        <div class="footer">
          <p>This email was sent from the Automation Factory ROI Calculator</p>
        </div>
      </div>
    </body>
    </html>
  `;
}